<template>
  <!-- 主界面 -->
  <div id="top" class="home_content" style="height: auto !important">
    <div class="carousel">
      <!---->
      <swiper
        :modules="modules"
        :slidesPerView="1"
        :spaceBetween="0"
        :navigation="{ nextEl: '.next', prevEl: '.prev' }"
        :loop="true"
        :autoplay="{
          delay: 5000,
          disableOnInteraction: false
        }"
        style=""
      >
        <swiper-slide v-for="(vo, i) in banner" :key="i">
          <!--[-->
          <div class="banner">
            <a href="javascript:" class="">
              <div class="img">
                <img :src="vo.img" crossorigin="anonymous" />
              </div>
            </a>
          </div>
        </swiper-slide>
      </swiper>
      <!---->
    </div>

    <!-- 精选 -->
    <list-item v-bind:title="$t('_sy._jx')" :cateId="1" moreUrl="hot"></list-item>

    <!-- 新品发布 -->
    <list-item v-bind:title="$t('_sy._xpfb')" :cateId="2" moreUrl="latest"></list-item>

    <!-- 更多视频 -->
    <list-item v-bind:title="$t('_sy._gdsp')" :cateId="3" moreUrl="hot"></list-item>

    <!-- 注册有礼 -->
    <RedBag ref="redbag"></RedBag>
  </div>
</template>

<script>
import { Navigation, Autoplay } from 'swiper'
import ListItem from '../components/vue/ListItem.vue'
import RedBag from '@/components/base/redbag.vue'
export default {
  name: 'IndexVue',
  components: {
    ListItem,
    RedBag
  },
  data() {
    return {
      modules: [Navigation, Autoplay],
      banner: []
    }
  },
  created() {
    //获取参数
    let code = this.$route.query?.code
    if (code) {
      //显示红包
      this.$nextTick(function () {
        this.$refs.redbag.show(code)
      })
    }
    this.getBanner()
    this.autoLogin()
  },
  methods: {
    getBanner() {
      let that = this
      //获取轮播
      this.$api.home
        .getBanner({
          type: 1
        })
        .then((res) => {
          that.banner = res.data
        })
    },
    autoLogin() {
      console.log('query', this.$route.query)
      if (this.$route.query.token) {
        //设置
        localStorage.setItem(this.$Const.KEY_TOKEN, this.$route.query.token)

        let that = this
        this.$api.user.getUserInfo().then((res) => {
          that.user = res.data
          localStorage.setItem(this.$Const.KEY_INFO, JSON.stringify(res.data))
          window.location.href = '/'
        })
      }
    }
  }
}
</script>

<style scoped>
@import url('../static/css/y-11.css');
@import url('../static/css/y-12.css');

/* @import url("../static/css/1.css"); */
/* @import url("../static/css/2.css"); */
@import url('../static/css/3.css');
@import url('../static/css/4.css');
@import url('../static/css/5.css');
/* @import url("../static/css/6.css"); */
/* @import url("../static/css/7.css"); */
@import url('../static/css/8.css');
@import url('../static/css/9.css');
@import url('../static/css/10.css');

@import url('../static/css/13.css');
@import url('../static/css/14.css');
@import url('../static/css/15.css');
@import url('../static/css/16.css');
@import url('../static/css/17.css');
@import url('../static/css/18.css');

/* 自定义 */
@import url('../static/css/19.css');
</style>
